var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-loop-scroll-box vue-loop-scroll",class:_vm.direction == 'left' ? 'left' : '',on:{"mouseenter":_vm.stopScroll,"mouseleave":_vm.leaveScroll}},[_c('ul',{staticClass:"vue-loop-scroll-item1"},[_vm._t("default")],2),_c('ul',{staticClass:"vue-loop-scroll-item2"})])
}
var staticRenderFns = []

export { render, staticRenderFns }